// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconNavMenuVertical = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      d="M11.38 24.01C9.52 24.01 8 22.5 8 20.63c0-1.87 1.51-3.38 3.38-3.38 1.86 0 3.38 1.51 3.38 3.38 0 1.87-1.52 3.38-3.38 3.38zm0-5.25c-1.03 0-1.88.84-1.88 1.88s.84 1.88 1.88 1.88c1.03 0 1.88-.84 1.88-1.88s-.84-1.88-1.88-1.88zm0-12C9.52 6.76 8 5.25 8 3.38 8 1.51 9.51 0 11.38 0c1.86 0 3.38 1.51 3.38 3.38 0 1.87-1.52 3.38-3.38 3.38zm0-5.25c-1.03 0-1.88.84-1.88 1.88s.84 1.88 1.88 1.88c1.03 0 1.88-.84 1.88-1.88s-.84-1.88-1.88-1.88zm0 13.88C9.52 15.39 8 13.88 8 12.01c0-1.86 1.51-3.37 3.38-3.37a3.38 3.38 0 013.38 3.37c0 1.86-1.52 3.38-3.38 3.38zm0-5.25c-1.03 0-1.88.84-1.88 1.87 0 1.03.84 1.88 1.88 1.88 1.03 0 1.88-.84 1.88-1.88 0-1.03-.84-1.87-1.88-1.87z"
      fill="currentColor"
    />
  );
export default SvgIconNavMenuVertical;
